/**
 * Lazy ELK instance: prefer elk-api + Web Worker (keeps main thread free), fall back to elk.bundled.
 */

let elkPromise = null;

function elkWorkerPublicUrl() {
  const base = process.env.PUBLIC_URL;
  if (base == null || base === '') {
    return '/elk-worker.min.js';
  }
  if (base === '.' || base === './') {
    return './elk-worker.min.js';
  }
  const trimmed = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${trimmed}/elk-worker.min.js`;
}

async function createElk() {
  if (typeof Worker === 'undefined') {
    const { default: ELKBundled } = await import('elkjs/lib/elk.bundled.js');
    return new ELKBundled();
  }

  const workerUrl = elkWorkerPublicUrl();
  try {
    const { default: ELKApi } = await import('elkjs/lib/elk-api.js');
    const elk = new ELKApi({ workerUrl });
    await elk.knownLayoutAlgorithms().catch(() => {});
    return elk;
  } catch (e) {
    console.warn('[elkSingleton] Web Worker ELK unavailable, using main-thread bundle.', e);
    const { default: ELKBundled } = await import('elkjs/lib/elk.bundled.js');
    return new ELKBundled();
  }
}

/** @returns {Promise<{ layout: (graph: object) => Promise<object> }>} */
export function ensureElk() {
  if (!elkPromise) {
    elkPromise = createElk();
  }
  return elkPromise;
}
